import React from 'react';
import Icon from '../../../components/AppIcon';


const AIPreviewSection = () => {
  const quickActions = [
    { icon: 'Wifi', label: 'WiFi Password', color: 'var(--color-primary)' },
    { icon: 'Calendar', label: 'Time Off Request', color: 'var(--color-accent)' },
    { icon: 'Users', label: 'Team Directory', color: 'var(--color-success)' },
    { icon: 'HelpCircle', label: 'IT Support', color: 'var(--color-warning)' }
  ];

  const chatMessages = [
    {
      type: 'user',
      text: 'How do I request time off?',
      time: '10:32'
    },
    {
      type: 'bot',
      text: 'Great question! To request time off, go to the HR Portal and click on "Time Off Request". Fill in the dates and reason, then submit for manager approval. You\'ll receive a notification within 24 hours.',
      time: '10:32'
    }
  ];

  return (
    <section className="py-20 px-6 bg-secondary/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-6">
            <Icon name="Sparkles" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">AI-Powered Assistant</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Meet Bee, Your AI Onboarding Companion
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Instant answers to common questions with company knowledge base integration, available 24/7 to support new hires
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-card border border-border rounded-lg shadow-elevation-2 overflow-hidden">
              <div className="bg-secondary/20 border-b border-border p-4 flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center">
                  <Icon name="Bot" size={20} color="var(--color-primary)" strokeWidth={2.5} />
                </div>
                <div>
                  <h4 className="font-semibold text-foreground">Bee Assistant</h4>
                  <div className="flex items-center gap-1 text-xs text-success">
                    <span className="w-2 h-2 bg-success rounded-full" />
                    <span>Online</span>
                  </div>
                </div>
              </div>

              <div className="p-6 space-y-4 h-80 overflow-y-auto bg-background/50">
                {chatMessages?.map((message, index) => (
                  <div
                    key={index}
                    className={`flex ${message?.type === 'user' ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-[80%] rounded-lg p-3 ${
                        message?.type === 'user' ?'bg-primary text-primary-foreground' :'bg-muted text-foreground'
                      }`}
                    >
                      <p className="text-sm mb-1">{message?.text}</p>
                      <span className="text-xs opacity-70">{message?.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-t border-border p-4 bg-card">
                <div className="flex flex-wrap gap-2 mb-3">
                  {quickActions?.map((action, index) => (
                    <button
                      key={index}
                      className="flex items-center gap-2 px-3 py-1.5 bg-muted/50 hover:bg-muted rounded-lg text-xs text-muted-foreground hover:text-foreground transition-colors duration-150"
                    >
                      <Icon name={action?.icon} size={14} color={action?.color} />
                      {action?.label}
                    </button>
                  ))}
                </div>
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="Ask Bee anything..."
                    className="flex-1 px-4 py-2 bg-input border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
                    disabled
                  />
                  <button className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity">
                    <Icon name="Send" size={18} color="var(--color-primary-foreground)" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-foreground mb-4">
                Intelligent Assistance, Always Available
              </h3>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Bee learns from your company's knowledge base to provide accurate, contextual answers to employee questions. Reduce manager interruptions by 80% while ensuring new hires get instant support.
              </p>
            </div>

            <div className="space-y-4">
              {[
                {
                  icon: 'Brain',
                  title: 'Context-Aware Responses',
                  description: 'Understands company-specific terminology and processes'
                },
                {
                  icon: 'Clock',
                  title: '24/7 Availability',
                  description: 'Support for remote teams across all time zones'
                },
                {
                  icon: 'TrendingUp',
                  title: 'Continuous Learning',
                  description: 'Improves accuracy with every interaction and feedback'
                },
                {
                  icon: 'Shield',
                  title: 'Secure & Private',
                  description: 'Enterprise-grade security for sensitive information'
                }
              ]?.map((feature, index) => (
                <div key={index} className="flex items-start gap-4 bg-card border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-all duration-300">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
                    <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground mb-1">{feature?.title}</h4>
                    <p className="text-sm text-muted-foreground">{feature?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIPreviewSection;